export type CopilotMessageRole = 'user' | 'assistant'

export type CopilotResultType = 'text' | 'html' | 'markdown'

export interface CopilotTextResult {
  type: 'text'
  content: string
}

export interface CopilotHtmlResult {
  type: 'html'
  content: string
}

export interface CopilotMarkdownResult {
  type: 'markdown'
  content: string
}

export type CopilotResult =
  | CopilotTextResult
  | CopilotHtmlResult
  | CopilotMarkdownResult

export interface CopilotThinkingActivity {
  kind: 'thinking'
  content: string
}

export interface CopilotToolActivity {
  kind: 'tool'
  id: string
  name: string
  input: unknown
  result: string | null
}

export interface CopilotLearningsActivity {
  kind: 'learnings'
  items: string[]
}

export type CopilotActivityEntry =
  | CopilotThinkingActivity
  | CopilotToolActivity
  | CopilotLearningsActivity

export interface CopilotMessage {
  role: CopilotMessageRole
  content: string
  displayLabel?: string
  result?: CopilotResult
  activity?: CopilotActivityEntry[]
  messageId?: string
}

export interface CopilotProgressEvent {
  type: 'progress'
  step: number
  label?: string
}

export interface CopilotResultEvent {
  type: 'result'
  result: CopilotResult
}

export interface CopilotThinkingEvent {
  type: 'thinking'
  content: string
}

export interface CopilotToolUseEvent {
  type: 'tool_use'
  id: string
  name: string
  input: unknown
}

export interface CopilotToolResultEvent {
  type: 'tool_result'
  id: string
  name: string
  result: string
}

export interface CopilotLearningsEvent {
  type: 'learnings'
  items: string[]
}

export interface CopilotSummaryEvent {
  type: 'summary'
  text: string
}

export type CopilotEvent =
  | CopilotProgressEvent
  | CopilotResultEvent
  | CopilotThinkingEvent
  | CopilotToolUseEvent
  | CopilotToolResultEvent
  | CopilotLearningsEvent
  | CopilotSummaryEvent

export interface CopilotHistoryTurn {
  role: CopilotMessageRole
  content: string
}

export interface CopilotConversation {
  id: string
  title: string | null
  messages: CopilotMessage[]
  isPinned: boolean
  createdAt: number
  updatedAt: number
}

// Backend API response shapes

export interface CopilotConversationListItem {
  id: string
  title: string
  is_pinned: boolean
  created_at: string
  updated_at: string
}

export enum CopilotQueryStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

export interface CopilotUserQueryFromApi {
  id: string
  content: string
  created_at: string
  status?: CopilotQueryStatus
  activity?: CopilotActivityEntry[]
}

export interface CopilotConversationDetail extends CopilotConversationListItem {
  messages: CopilotUserQueryFromApi[]
}

export interface CopilotQueryResponse {
  conversation_id: string
  message_id: string
}

export interface CopilotResultResponse {
  id: string
  result_type: CopilotResultType
  content: string
}
